export const address = (location) =>
  `${location.address1} ${location.address2 ? location.address2 : ""}`.trim();
